import type { ReactNode } from "react";
import { LinedTabs, type LinedTabsItem } from "ui-kit/src/LinedTabs/LinedTabs";
import type { NavOptions } from "../types";

interface LinedTabsAdapterProps {
	active: NavOptions;
	children?: ReactNode;
	onChange?: (key: NavOptions) => void;
	tabs: LinedTabsItem[];
}

function StatsLinedTabsAdapter({ tabs, active, children, onChange }: LinedTabsAdapterProps) {
	const handleChange = (key: string) => {
		onChange?.(key as NavOptions);
	}

	return (
		<LinedTabs items={tabs} active={active} onChange={handleChange}>
			{children}
		</LinedTabs>
	);
}

export { StatsLinedTabsAdapter }
